import styled from "styled-components";
import { LAYOUT } from "@/constants/styles";

export const StyledEmailVerificationContent = styled.div`
  margin: 0 0 ${LAYOUT.GUTTER * 2}px;

  h2 {
    margin-top: 0;
  }
`;
